import {
  LoginRequest,
  PasswordLoginResponse,
  RegisterRequest,
  RegisterResponse,
} from "../../types/authTypes";
import customFetch from "../../util/config/axiosConfig";

const getApiError = (data: any, fallback: string): string =>
  (typeof data?.error === "string" ? data.error : data?.error?.message) ||
  data?.message ||
  fallback;

const userService = {
  passwordLogin: async (
    payload: LoginRequest
  ): Promise<PasswordLoginResponse> => {
    const response = await customFetch.post("api/auth/login", {
      emailOrMobile: payload.emailOrMobile,
      password: payload.password,
    });

    if (response.data.status !== 1) {
      throw new Error(getApiError(response.data, "Login failed"));
    }

    return response.data as PasswordLoginResponse;
  },

  register: async (payload: RegisterRequest): Promise<RegisterResponse> => {
    const response = await customFetch.post("api/auth/register", {
      fullName: payload.fullName,
      mobile: payload.mobile,
      email: payload.email,
      password: payload.password,
    });

    if (response.data.status !== 1) {
      throw new Error(getApiError(response.data, "Registration failed"));
    }

    return response.data as RegisterResponse;
  },
};

export { getApiError };
export default userService;
